import * as types from '../../mutation-types'

const mutations = {
  [types.GET_QUOTE_BY_RACE] (state, { quote }) {
    state.quote = quote
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/raceQuote/mutations.js